import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';
import { AppLoaderPage } from '@gokrew/ui/components/AppLoaderPage';

export function MockLoginPage() {
  const [searchParams] = useSearchParams();
  const { setMockLoginToken } = useEmployeePortalAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      setMockLoginToken(token);
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, []);

  return <AppLoaderPage />;
}
